export default "/images/broadAffinity.svg?81ffebc8ff40f2d4bace8afd697d25f5";